import { render, staticRenderFns } from "./newsListByCategory.vue?vue&type=template&id=5020580c&scoped=true&"
import script from "./newsListByCategory.vue?vue&type=script&lang=js&"
export * from "./newsListByCategory.vue?vue&type=script&lang=js&"
import style0 from "./newsListByCategory.vue?vue&type=style&index=0&id=5020580c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5020580c",
  null
  
)

export default component.exports